var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 48,
    rx: 6,
    fill: "url(#paint0_linear_462_4254)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5238 14.2788C42.5018 14.1187 42.3616 14.0302 42.2457 14.0204C42.1301 14.0108 39.6827 13.8294 39.6827 13.8294C39.6827 13.8294 37.983 12.1419 37.7964 11.9551C37.6098 11.7685 37.2452 11.8253 37.1037 11.8669C37.0829 11.873 36.7323 11.9812 36.1525 12.1607C35.5847 10.5268 34.5826 9.02537 32.8198 9.02537C32.7711 9.02537 32.721 9.02734 32.6709 9.03019C32.1696 8.36716 31.5485 8.0791 31.0121 8.0791C26.9055 8.0791 24.9436 13.2127 24.3285 15.8214C22.7328 16.3159 21.5992 16.6674 21.4544 16.7129C20.5637 16.9923 20.5355 17.0204 20.4186 17.8596C20.3305 18.4951 18 36.5182 18 36.5182L36.16 39.9207L45.9998 37.7921C45.9998 37.7921 42.5456 14.4388 42.5239 14.2788H42.5238ZM35.1488 12.4711L33.6122 12.9467C33.6127 12.8384 33.6132 12.7318 33.6132 12.6153C33.6132 11.5999 33.4723 10.7823 33.2462 10.1342C34.1545 10.2482 34.7594 11.2817 35.1488 12.4711ZM32.1194 10.3355C32.3719 10.9683 32.5361 11.8764 32.5361 13.1019C32.5361 13.1646 32.5356 13.2219 32.535 13.2799C31.5357 13.5894 30.4498 13.9255 29.3615 14.2627C29.9725 11.9043 31.118 10.7652 32.1194 10.3355ZM30.8993 9.18058C31.0765 9.18058 31.2551 9.24075 31.426 9.35837C30.1099 9.97766 28.6992 11.5374 28.1035 14.6522L25.5949 15.4291C26.2927 13.0533 27.9496 9.18058 30.8992 9.18058H30.8993Z",
    fill: "#95BF46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2462 14.0202C42.1305 14.0106 39.6832 13.8292 39.6832 13.8292C39.6832 13.8292 37.9834 12.1417 37.7969 11.9549C37.7271 11.8854 37.6329 11.8498 37.5345 11.8345L36.1614 39.9203L46.0002 37.7919C46.0002 37.7919 42.546 14.4386 42.5243 14.2786C42.5022 14.1185 42.362 14.03 42.2462 14.0202Z",
    fill: "#5E8E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8203 19.4574L31.607 23.0665C31.607 23.0665 30.544 22.4991 29.241 22.4991C27.3307 22.4991 27.2346 23.6979 27.2346 24C27.2346 25.6483 31.5313 26.2799 31.5313 30.1408C31.5313 33.1785 29.6047 35.1345 27.0069 35.1345C23.8896 35.1345 22.2954 33.1944 22.2954 33.1944L23.1301 30.4366C23.1301 30.4366 24.7688 31.8434 26.1515 31.8434C27.055 31.8434 27.4225 31.132 27.4225 30.6123C27.4225 28.4621 23.8975 28.3662 23.8975 24.8332C23.8975 21.8595 26.0318 18.9819 30.3402 18.9819C32.0002 18.9819 32.8203 19.4574 32.8203 19.4574Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_462_4254",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56E6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EF78D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopify);
export default __webpack_public_path__ + "static/media/shopify.9a3d9bd40866ad6b80bb38035b84065f.svg";
export { ForwardRef as ReactComponent };